import {useState,useEffect,useRef}from 'react'
import { Modal,App,Form,Input,} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useBnsXiangMuBanBenUpdateQuery, useBnsXiangMuBanBenUpdateSaveMutation } from '../../store/BnsKeJiApi';
import UploadOne from '../../cpn/UploadOne';
const {TextArea} = Input;
function SketchEdit(props) {
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [info,setInfo] = useState({
        'bxmbb_id': props.bxmbb_id,
        'bxmbb_bxm_name': props.bxm_name,
        'bxmbb_name': '',
        'bxmbb_image': '',
        'bxmbb_content': '',
        'bxmbb_cid': props.eu_id,
        'bxmbb_cname': props.eu_name,
        'bxmbb_bxm_id': props.bxm_id,
        'bxmbb_yh_id': props.yh_id,
        'bxmbb_yh_name': props.yh_name,
        'bxmbb_xq_id': props.bxmxq_id,
        'bxmbb_xq_name': props.bxmxq_name,
    }); 
    const [defaultFileList, setDefaultFileList] = useState([]); 
    const {data,isSuccess} = useBnsXiangMuBanBenUpdateQuery({bxmbb_id:props.bxmbb_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bxmbb_content:data.Result.bxmbb_content,
                    bxmbb_name:data.Result.bxmbb_name,
                })
                setInfo(prevState=>({...prevState,         
                    bxmbb_content:data.Result.bxmbb_content,                         
                    bxmbb_name:data.Result.bxmbb_name,        
                    bxmbb_image:data.Result.bxmbb_image,
                }))
                // 将图片字符串转换为 UploadOne 组件需要的 defaultFileList 格式
                if(data.Result.bxmbb_image && data.Result.bxmbb_image.trim() !== '') {
                    const imageFiles = [{
                        uid: `existing-${data.Result.bxmbb_image}`,
                        name: data.Result.bxmbb_image,
                        status: 'done',
                        url: `/api/assets/images/application/${data.Result.bxmbb_image}`,
                        thumbUrl: `/api/assets/images/application/${data.Result.bxmbb_image}`,
                    }]
                    setDefaultFileList(imageFiles);
                } else {
                    setDefaultFileList([]);
                }
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsXiangMuBanBenUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined/> 修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改界面'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    goodsEdit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_sketch_edit_${props.bxmbb_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <Form.Item
                        name="bxmbb_name"
                        label="名称"
                        wrapperCol={{ span: 20 }}
                    >
                        <Input
                            onChange={(e) => {
                                setInfo(prevState => ({ ...prevState, bxmbb_name: e.target.value }))
                            }}
                        />
                    </Form.Item>
                    <UploadOne
                        fileStr={(fileStr) => { setInfo(prevState => ({ ...prevState, bxmbb_image: fileStr })) }} 
                        label="效果图"
                        name="bxmbb_image"
                        defaultFileList={defaultFileList}
                        maxCount={1}
                    />
                    <Form.Item 
                        name="bxmbb_content" 
                        label='备注' 
                        wrapperCol={{span:21}}                            
                    >
                        <TextArea  onChange={(e) => {setInfo(prevState=>({...prevState,bxmbb_content:e.target.value}))}}/>
                    </Form.Item>  
                </Form>
            </Modal>
        </>
    )
}

export default SketchEdit
